"use strict";

var VEHICLE_CATEGORY_CODES = {
  'outlander': 'Cat-C',
  'outlander phev': 'Cat-B',
  'eclipse cross': 'Cat-C',
  'rvr': 'Cat-B',
  'mirage': 'Cat-A'
};
var NAMEPLATES = {
  'outlander phev': ['Outlander PHEV', '2024 OUTLANDER PHEV', 'Outlander Phev 2024', 'Outlander Phev 2025', '2025 Outlander Phev'],
  'outlander': ['Outlander', '2024 OUTLANDER', 'Outlander 2024', '2025 OUTLANDER', 'Outlander 2025'],
  'eclipse cross': ['eclipse cross', '2024 eclipse cross', 'eclipse cross 2024', '2025 eclipse cross', 'eclipse cross 2025'],
  'rvr': ['rvr', '2024 rvr', 'rvr 2024', '2025 rvr', 'rvr 2025'],
  'mirage': ['mirage', 'mirage 2024', '2024 mirage', 'mirage 2025', '2025 mirage']
};
var getNameplateByVehicleName = function getNameplateByVehicleName(vehicleName) {
  var _nameplate;
  var nameplate;
  if (vehicleName) {
    Object.values(NAMEPLATES).forEach(function (names, index) {
      var itemFound = names.filter(function (item) {
        return item.toLowerCase() === vehicleName.toLowerCase();
      });
      if (itemFound && itemFound.length > 0) {
        nameplate = Object.keys(NAMEPLATES)[index];
      }
      ;
    });
  }
  return (_nameplate = nameplate) == null ? void 0 : _nameplate.toLowerCase();
};
module.exports = {
  VEHICLE_CATEGORY_CODES: VEHICLE_CATEGORY_CODES,
  NAMEPLATES: NAMEPLATES,
  getNameplateByVehicleName: getNameplateByVehicleName
};